"use client";

import { useEffect } from "react";
import { ErrorPage } from "skedyul-ui/ui";
import "skedyul-ui/app/globals.css";

function readStoredTheme(): "light" | "dark" {
  if (typeof window === "undefined") {
    return "light";
  }
  try {
    const stored = window.localStorage.getItem("theme");
    if (stored === "dark" || stored === "light") {
      return stored;
    }
  } catch {
    // localStorage can throw in restricted contexts
  }
  return "light";
}

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const theme = readStoredTheme();

  useEffect(() => {
    console.error("Global error boundary:", error);
  }, [error]);

  return (
    <html lang="en_AU" dir="ltr" data-theme={theme} suppressHydrationWarning>
      <body>
        <ErrorPage
          digest={
            process.env.NODE_ENV !== "production" ? error.digest : undefined
          }
          primaryAction={{
            label: "Try again",
            onClick: () => {
              reset();
            },
          }}
          secondaryAction={{
            label: "Go to home",
            onClick: () => {
              window.location.assign("/");
            },
          }}
        />
      </body>
    </html>
  );
}
